import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { isCustomerUser, isPartner, isStaff } from '@/utils/access'

export function RequireAuth() {
  const profile = useAuthStore((s) => s.profile)
  const loc = useLocation()
  if (!profile) {
    return <Navigate to="/login" state={{ from: loc }} replace />
  }
  return <Outlet />
}

/** Только роль admin */
export function AdminOnly() {
  const profile = useAuthStore((s) => s.profile)
  if (profile?.role !== 'admin') {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}

/** Только admin со флагом has_pd_access */
export function PdOnly() {
  const profile = useAuthStore((s) => s.profile)
  if (profile?.role !== 'admin' || !profile.has_pd_access) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}

/**
 * Блокирует доступ для пользователей заказчика (manager/customer_supervisor).
 * Используется для маршрутов, куда заказчикам нельзя: Companies, Users, Audit и т.д.
 */
export function StaffOnly() {
  const profile = useAuthStore((s) => s.profile)
  if (isCustomerUser(profile)) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}

/** Только платформа: admin или dispatcher (карта заказов и т.п.). */
export function PlatformOnly() {
  const profile = useAuthStore((s) => s.profile)
  if (!isStaff(profile)) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}

/** Рабочая консоль — не для партнёра: его место — кабинет /partner. */
export function NotPartner() {
  const profile = useAuthStore((s) => s.profile)
  if (isPartner(profile)) {
    return <Navigate to="/partner" replace />
  }
  return <Outlet />
}

/** Кабинет партнёра — только роли partner_operator / partner_viewer. */
export function PartnerOnly() {
  const profile = useAuthStore((s) => s.profile)
  if (!isPartner(profile)) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}
